<div class="sticky-table-container">
    <p-table stripedRows [value]="items" dataKey="PostingType" #dtPosting (onEditInit)="onEditInit($event)"
        (onEditComplete)="onEditComplete($event)" editMode="row" [style]="{ 'min-width': '70em' }"
        selectionMode="single">
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="4" style="text-align: center">
                    <div class="tabulator-placeholder">
                        <span> No Data Available </span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template #header let-item>
            <tr>
                <!-- Edit -->
                <th class="edit-cell"></th>
                <!-- Status -->
                <th class="status-cell">
                    <i class="pi pi-exclamation-circle" title="Status"></i>
                </th>
                <!-- Posting Item -->
                <th>
                    Posting Item
                    <p-sortIcon pSortableColumn="Postingtypedesc" field="Postingtypedesc" ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    <p-columnFilter type="text" matchMode="contains" field="Postingtypedesc" display="menu" class="ml-auto" />
                </th>
                <!-- Assigned Item -->
                <th>
                    Assigned Item
                    <p-sortIcon pSortableColumn="ServiceItemDescription" field="ServiceItemDescription"
                        ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    <p-columnFilter type="text" matchMode="contains" field="ServiceItemDescription" display="menu" class="ml-auto" />
                </th>
            </tr>
        </ng-template>
        <ng-template #body let-item let-edit="editing" let-ri="rowIndex">
            <tr [pSelectableRow]="item" [pEditableRow]="item" [ngClass]="{
                    'ui-editing-row':
                        edit && editing?.PostingType === item?.PostingType
                }">
                <!-- Edit -->
                <td class="edit-cell">
                    <button *ngIf="
                            !edit &&
                            (!editing?.PostingType ||
                                editing?.PostingType === item?.PostingType)
                        " pButton type="button" pInitEditableRow icon="pi pi-pencil"
                        class="p-button-rounded p-button-text" (click)="onRowEditInit(item)" title="Edit"></button>
                    <button *ngIf="edit" pButton type="button" pSaveEditableRow icon="pi pi-check" class="
                            p-button-rounded p-button-text p-button-success
                        " (click)="onRowEditSave(item)"></button>
                    <button *ngIf="edit" pButton type="button" pCancelEditableRow icon="pi pi-times" class="
                            p-button-rounded p-button-text p-button-danger
                        " (click)="onRowEditCancel(item)"></button>
                </td>
                <!-- Status -->
                <td class="status-cell">
                    <div (click)="onStatusClick(item)" class="status-cell">
                        <ef-status-icon [status]="item?.Status?.StatusCode"
                            [message]="item?.Status?.Message"></ef-status-icon>
                    </div>
                </td>
                <!-- Posting Item -->
                <td class="disabled">
                    {{ item?.Description }}
                </td>
                <!-- Assigned Item -->
                <td>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <div>
                                <p-select appendTo="body" [options]="
                                        getServiceItemsForPosting(
                                            item.PostingType
                                        )
                                    " [filter]="true" [(ngModel)]="item.ListID"></p-select>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="output">
                            <div data-toggle="tooltip" data-placement="top" [attr.title]="
                                    (
                                        serviceItems
                                        | itemlookup: 'SIListID':item?.ListID
                                    )?.ServiceItemDescription
                                ">
                                {{
                                (
                                serviceItems
                                | itemlookup: 'SIListID':item?.ListID
                                )?.ServiceItemDescription
                                }}
                            </div>
                        </ng-template>
                    </p-cellEditor>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
